import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";
import {
  addSlashestoApiNames,
  checkIfSuperAdmin,
  getActiveClass,
  getUrlLastPart,
  hasPermission,
} from "../../helpers/helpers";

const SidebarContent = (props) => {
  console.log(props);
  const { Users } = props;
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  // useEffect(() => {
  //   const pathName = props.location.pathname

  //   const initMenu = () => {
  //     new MetisMenu("#side-menu")
  //     let matchingMenuItem = null
  //     const ul = document.getElementById("side-menu")
  //     const items = ul.getElementsByTagName("a")
  //     for (let i = 0; i < items.length; ++i) {
  //       if (pathName === items[i].pathname) {
  //         matchingMenuItem = items[i]
  //         break
  //       }
  //     }
  //     if (matchingMenuItem) {
  //       activateParentDropdown(matchingMenuItem)
  //     }
  //   }
  //   initMenu()
  // }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }
  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            <li>
              <Link to="/dashboard" className={getActiveClass("dashboard")}>
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            {/* <li className={getActiveClass("users")}>
              <Link to="/#" className={`has-arrow users `}>
                <i className="bx bxs-user-detail"></i>
                <span>{props.t("Admin")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                {Users.map((user) => (
                  <li
                    key={user.id}
                    className={getActiveClass(addSlashestoApiNames(user.label))}
                  >
                    <Link to="/#">
                      <i className="bx bx-user"></i>
                      {props.t(user.label)}
                    </Link>
                  </li>
                ))}

                <li>
                  <Link to="/#">
                    <i className="bx bxs-user"></i>
                    <span>{props.t("End Users")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/#"
                  // to="/admin/shops"
                  // className={`${getActiveClass("shops")}`}
                  >
                    <i className="bx bxs-cart"></i>
                    <span>{props.t("Shops")}</span>
                  </Link>
                </li>

                <li>
                  <Link to="/#"
                  // to="/admin/cashiers"
                  // className={`${getActiveClass("cashiers")}`}
                  >
                    <i className="bx bx-money"></i>
                    <span>{props.t("Cashiers")}</span>
                  </Link>
                </li>

                <>
                  <li>
                    <Link to="/#"
                    // to="/permissions"
                    // className={`${getActiveClass("permissions")}`}
                    >
                      <i className="bx bx-lock"></i>
                      <span>{props.t("Permissions")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/#">
                      <i className="bx bx-user-plus"></i>
                      <span>{props.t("Roles")}</span>
                    </Link>
                  </li>
                </>
              </ul>
            </li> */}

            {/* <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-cog"></i>
                <span>{props.t("Settings")}</span>
              </Link>

              <ul className="sub-menu" aria-expanded="true">
                <li>
                  <Link to="/#">
                    <i className="bx bx-book-add"></i>
                    {props.t("Products")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className="bx bxs-timer"></i>

                    {props.t("Access Expiration")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className="bx bxs-user-detail"></i>

                    {props.t("Operator Products")}
                  </Link>
                </li>

                <li>
                  <Link to="/#" className="text-nowrap">
                    <i className="bx bx-money"></i>

                    {props.t("Supplier Commissions")}
                  </Link>
                </li>
              </ul>
            </li> */}

            {/* <li>
              <Link to="/#" className="has-arrow">
                <i className=" bx bx-dock-bottom"></i>
                <span>{props.t("Risk Management")}</span>
              </Link>

              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/#">
                    <i className="bx bx-list-ul"></i>

                    {props.t("Parameters")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-id-card"></i>

                    {props.t("Risk per user")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-id-card"></i>
                    {props.t("KYC")}
                  </Link>
                </li>
              </ul>
            </li> */}

            {/* <li>
              <Link to="/#">
                <i className=" bx bx-caret-down-circle"></i>
                <span>{props.t("Accounting")}</span>
              </Link>

              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/#">
                    <i className=" bx bx-brain"></i>

                    {props.t("End User Accounts")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-brain"></i>

                    {props.t("Cashier Accounts")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-up-arrow-circle"></i>

                    {props.t("Deposits")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-down-arrow-circle"></i>

                    {props.t("Withdrawals")}
                  </Link>
                </li>
              </ul>
            </li> */}

            {/* <li>
              <Link to="/#" className="has-arrow">
                <i className=" bx bx-message-square-check"></i>
                <span>{props.t("Reports")}</span>
              </Link>

              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/#">
                    <i className="bx bx-medal"></i>

                    {props.t("Sports Tickets")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className="bx bx-medal"></i>

                    {props.t("Book-A-Bet Tickets")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className="bx bx-game"></i>

                    {props.t("Games Tickets")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className="bx bx-game"></i>

                    {props.t("Games Reports")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-gift"></i>

                    {props.t("Jackpot Tickets")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-gift"></i>

                    {props.t("Jackpot Report")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-gift"></i>

                    {props.t("Cashiers Reports")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-gift"></i>

                    {props.t("Shop Reports")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-gift"></i>

                    {props.t("Kiron Tickets")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-user"></i>

                    {props.t("Customers Report")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-dollar-circle"></i>

                    {props.t("Bonus Report")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className=" bx bx-dollar-circle"></i>

                    {props.t("MultiBet Bonus Report")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className=" bx bx-dollar-circle"></i>

                    {props.t("Acca7 Report")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className=" bx bx-dollar-circle"></i>

                    {props.t("Bonus Tickets")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className="bx bx-dollar-circle"></i>

                    {props.t("RAF Com Report")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className=" bx bx-money"></i>

                    {props.t("Mimo Report")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className=" bx bx-spreadsheet"></i>

                    {props.t("Tax Report")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className=" bx bx-group"></i>

                    {props.t("Suppliers Report")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className=" bx bx-detail"></i>

                    {props.t("Board Report")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className=" bx bx-selection"></i>

                    {props.t("GGR Report")}
                  </Link>
                </li>

                <li>
                  <Link to="/#">
                    <i className="bx bx-game"></i>

                    {props.t("Book-A-Bet Reports")}
                  </Link>
                </li>
                <li>
                  <Link to="/#" to>
                    <i className=" bx bx-message"></i>

                    {props.t("SMS Logs")}
                  </Link>
                </li>
              </ul>
            </li> */}

            {/* <li>
              <Link to="/#"  className="has-arrow">
                <i className="bx bx-pie-chart"></i>
                <span>{props.t("CRM")}</span>
              </Link>

              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/#">
                    <i className="bx bx-news"></i>

                    {props.t("Marketing")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className="bx bx-chart"></i>
                    {props.t("Analytics")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className="bx bx-menu"></i>

                    {props.t("Static Pages")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className="bx bx-spreadsheet"></i>

                    {props.t("Content")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className="bx bx-spreadsheet"></i>

                    {props.t("Sports")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className="bx bx-spreadsheet"></i>

                    {props.t("Locations")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className="bx bx-spreadsheet"></i>

                    {props.t("Leagues")}
                  </Link>
                </li>
                <li>
                  <Link to="/#">
                    <i className="bx bx-spreadsheet"></i>

                    {props.t("Campaigns")}
                  </Link>
                </li>
              </ul>
            </li> */}

            {/* <Link to="/#" className="has-arrow">
              <i className="bx bx-aperture"></i>
              <span>{props.t("Promotions")}</span>
            </Link> */}

            {/* <ul className="sub-menu" aria-expanded="false">
              <li>
                <Link to="/#">
                  <i className="bx bx-bullseye"></i>

                  {props.t("Bonuses")}
                </Link>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bxs-dollar-circle"></i>

                  {props.t("Multi Bet Bonus")}
                </Link>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bx-trending-up"></i>

                  {props.t("Jackpots")}
                </Link>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bx-trending-up"></i>

                  {props.t("Acca7")}
                </Link>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bx-trending-up"></i>

                  {props.t("Freebets")}
                </Link>
              </li>
              <li>
                <Link to="/#">
                  <i className="bx bx-trending-up"></i>

                  {props.t("AutometedFreeSpin")}
                </Link>
              </li>
            </ul> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

export default withTranslation()(SidebarContent);
